import injectSheet, { createStyles } from 'core/style/injectSheet';
import { ITheme, WithStyles } from 'core/style/interfaces';
import React from 'react';
import BaseSubscription from '../components/BaseSubscription';
import LinkAccess from '../components/LinkAccess';

const SubscriptionsContent: React.FC<WithStyles<typeof styles>> = ({ classes }) => {
    return (
        <div className={classes.root}>
            <div className={classes.subscribeWrapper}>
                <div className={classes.title}>Базовая подписка:</div>
                <BaseSubscription />
            </div>
            <div className={classes.subscribeWrapper}>
                <div className={classes.title}>Доступ к видеозаписям и материалам:</div>
                <LinkAccess />
            </div>
        </div>
    );
};

const styles = (theme: ITheme) =>
    createStyles({
        root: {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
        },
        warningWrapper: {
            width: 100 + '%',
            marginBottom: 1 + 'rem',
        },
        subscribeWrapper: {
            width: 550,
            display: 'flex',
            flexDirection: 'column',
            marginBottom: 1 + 'rem',

            [theme.breakpoints.down('md')]: {
                width: 100 + '%',
            },
        },
        title: {
            fontSize: 1 + 'rem',
            fontWeight: 'bold',
            marginBottom: 1 + 'rem',
        },
    });

export default injectSheet(styles, 'SubscriptionsContent')(SubscriptionsContent);
